<app-fixed-editor *ngIf="_element.editorId && fixedEditor && !isSubmitted" [element]="fixedEditor"></app-fixed-editor>

<div class="new-question new-question-top-align mx-auto" *ngIf="!isSubmitted && !immediateFeedBackRequired" [attr.id]="'destination'+index" [class.fullheight-scroll-container]="!isSubmitted">
    <div class="new-question__container">
        <h2 class="mg-b60 text-center montserrat-bold font-16" [froalaView]="_element?.question"></h2>
        <div class="rating-type">
            <div class="rating-type__bar">
                <div class="rating-type__bar-wrapper rating-type__bar-left">
                      <div class="rating-type__pipe" *ngFor="let opt of negativeArray; index as i" id="rating_id_left{{opt?._id}}">
                          <div class="rating-type__pipe-pillar">
                              <span [ngStyle]="{'height': (100 - (i * (100/negativeArray.length)))+'%', 'opacity': (1 - (i * (1/negativeArray.length)))}" class="rating-type__pipe-pillar-bg"></span>
                          </div>
                          <div class="rating-type__pipe-text">{{opt.text}}</div>
                      </div>
                      <div class="rating-type__pipe">
                        <div class="rating-type__pipe-pillar">
                            <span style="height: 0%; opacity: 0;" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text"></div>
                    </div>
                </div>
                <div class="rating-type__bar-wrapper rating-type__bar-center">
                    <div class="rating-type__pipe rating-type__pipe--active" *ngFor="let opt of centralLabel; index as i" id="rating_id_center{{opt?._id}}">
                        <div class="rating-type__pipe-pillar">
                            <span style="height: 15%; opacity: 0.2;" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text">{{opt.text}}</div>
                    </div>
                </div>
                <div class="rating-type__bar-wrapper rating-type__bar-right">
                    <div class="rating-type__pipe">
                        <div class="rating-type__pipe-pillar">
                            <span style="height: 0%; opacity: 0;" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text"></div>
                    </div>
                    <div class="rating-type__pipe" id="rating_id_right{{opt?._id}}"
                    *ngFor="let opt of positiveArray; index as i">
                        <div class="rating-type__pipe-pillar">
                            <span [ngStyle]="{'height': (i+1)*(100/positiveArray.length)+'%','opacity': (i+1)*(1/positiveArray.length)}" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text">{{opt.text}}</div>
                    </div>
                </div>
                <div class="rating-slider-container">
                    <input type="range" min="{{-(positiveArray.length)}}" max="{{positiveArray.length}}" value="0" class="rating-custom-slider" id="myRange" (change)="showVal($event)">
                </div>
            </div>
            <div class="rating-type__text pd-t20">
                <p>{{_element?.statementOne}}</p>
                <p>{{_element?.statementTwo}}</p>
            </div>
        </div>
        <div class="text-center p-4">
          <app-exercise-navigation-bar [id]="id" [questionAttempted]="selectedOption" (onNext)="next(selectedOption)"
          (onSubmit)="next(selectedOption, true)"
          [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
          [index]='index'
          >
        </app-exercise-navigation-bar>
        </div>
    </div>
  </div>





  <div class="new-question new-question-top-align mx-auto" *ngIf="!isSubmitted && immediateFeedBackRequired" [attr.id]="'destination'+index" [class.fullheight-scroll-container]="!isSubmitted">
    <div class="new-question__container">
        <h2 class="mg-b60 text-center montserrat-bold font-16" [froalaView]="_element?.question"></h2>
        <div class="rating-type">
            <div class="rating-type__bar">
                <div class="rating-type__bar-wrapper rating-type__bar-left">
                      <div class="rating-type__pipe" *ngFor="let opt of negativeArray; index as i" id="rating_id_left{{opt?._id}}">
                          <div class="rating-type__pipe-pillar">
                              <span [ngStyle]="{'height': (100 - (i * (100/negativeArray.length)))+'%', 'opacity': (1 - (i * (1/negativeArray.length)))}" class="rating-type__pipe-pillar-bg"></span>
                          </div>
                          <div class="rating-type__pipe-text">{{opt.text}}</div>
                      </div>

                      <div class="rating-type__pipe">
                        <div class="rating-type__pipe-pillar">
                            <span style="height: 0%; opacity: 0;" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text"></div>
                    </div>
                </div>
                <div class="rating-type__bar-wrapper rating-type__bar-center">
                    <div class="rating-type__pipe  rating-type__pipe--active" *ngFor="let opt of centralLabel; index as i" id="rating_id_center{{opt?._id}}">
                        <div class="rating-type__pipe-pillar">
                            <span style="height: 15%; opacity: 0.2;" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text">{{opt.text}}</div>
                    </div>
                </div>
                <div class="rating-type__bar-wrapper rating-type__bar-right">
                    <div class="rating-type__pipe">
                        <div class="rating-type__pipe-pillar">
                            <span style="height: 0%; opacity: 0;" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text"></div>
                    </div>
                    <div class="rating-type__pipe" id="rating_id_right{{opt?._id}}"
                    *ngFor="let opt of positiveArray; index as i">
                        <div class="rating-type__pipe-pillar">
                            <span [ngStyle]="{'height': (i+1)*(100/negativeArray.length)+'%','opacity': (i+1)*(1/negativeArray.length)}" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text">{{opt.text}}</div>
                    </div>
                </div>
                <div class="rating-slider-container">
                    <input type="range" min="{{-(positiveArray.length)}}" max="{{positiveArray.length}}" value="0" class="rating-custom-slider" id="myRange" (change)="showVal($event)">
                </div>
            </div>
            <div class="rating-type__text pd-t20">
                <p>{{_element?.statementOne}}</p>
                <p>{{_element?.statementTwo}}</p>
            </div>
        </div>
        <div class="text-center p-4">
        <app-exercise-navigation-bar [id]="id" [immediateFeedBackRequired]="true" [questionAttempted]="selectedOption" (onReview)="check()" (onNext)="next(selectedOption)"
        (onSubmit)="next(selectedOption, true)" [questionChecked]="questionChecked"
        [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
        [index]='index'
        >
      </app-exercise-navigation-bar>
        </div>
    </div>
</div>




<div class="new-question new-question-top-align mx-auto" *ngIf="isSubmitted" [attr.id]="'destination'+index" [class.new-options--not-answered]="!_answer" [class.fullheight-scroll-container]="!isSubmitted">
    <div class="new-question__container">
        <h2 class="mg-b60 text-center montserrat-bold font-16" [froalaView]="_element?.question"></h2>
        <div class="rating-type">
            <div class="rating-type__bar" style="pointer-events: none;">
                
                <div class="rating-type__bar-wrapper rating-type__bar-left">
                      <div class="rating-type__pipe" *ngFor="let opt of negativeArray; index as i" id="rating_id_left{{opt?._id}}">
                          <div class="rating-type__pipe-pillar">
                              <span [ngStyle]="{'height': (100 - (i * (100/negativeArray.length)))+'%', 'opacity': (1 - (i * (1/negativeArray.length)))}" class="rating-type__pipe-pillar-bg"></span>
                          </div>
                          <div class="rating-type__pipe-text">{{opt.text}}</div>
                      </div>
                      <div class="rating-type__pipe">
                        <div class="rating-type__pipe-pillar">
                            <span style="height: 0%; opacity: 0;" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text"></div>
                    </div>
                </div>
                <div class="rating-type__bar-wrapper rating-type__bar-center">
                    <div class="rating-type__pipe rating-type__pipe--active" *ngFor="let opt of centralLabel; index as i" id="rating_id_center{{opt?._id}}">
                        <div class="rating-type__pipe-pillar">
                            <span style="height: 15%; opacity: 0.2;" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text">{{opt.text}}</div>
                    </div>
                </div>
                <div class="rating-type__bar-wrapper rating-type__bar-right">
                    <div class="rating-type__pipe">
                        <div class="rating-type__pipe-pillar">
                            <span style="height: 0%; opacity: 0;" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text"></div>
                    </div>
                    <div class="rating-type__pipe" id="rating_id_right{{opt?._id}}"
                    *ngFor="let opt of positiveArray; index as i">
                        <div class="rating-type__pipe-pillar">
                            <span [ngStyle]="{'height': (i+1)*(100/negativeArray.length)+'%','opacity': (i+1)*(1/negativeArray.length)}" class="rating-type__pipe-pillar-bg"></span>
                        </div>
                        <div class="rating-type__pipe-text">{{opt.text}}</div>
                    </div>
                </div>
            </div>
            <div class="rating-type__text pd-t20">
                <p>{{_element?.statementOne}}</p>
                <p>{{_element?.statementTwo}}</p>
            </div>
        </div>
        <!-- thrive -->
        <ng-container *ngIf="questionBlos && questionBlos.length">     
            <h5 class="question__thrive">Thrive Skills:</h5>
            <div class="question__thrive-list">
            <ul>
                <ng-container *ngFor="let blo of questionBlos">
                    <li [innerHTML]="blo.shortStatement"></li>
                  </ng-container>
            </ul>
            </div>
        </ng-container>

        <div *ngIf="_element?.isFeedbackEnabled" class="overall-feedback">
            <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
            <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
          </div>
    </div>

    <!-- <app-like-dislike [id]="id" *ngIf="_element?.isFeedbackEnabled" [userFeedback]="userFeedback" [_element]="_element"
    (reportFeedback)="_reportFeedback($event)" (likeDislike)="_likeDislike($event)">
  </app-like-dislike> -->
</div>